<style>

    .ant-layout-header {
        display: none;
    }

    table td, th {
        padding: 8px 8px;
    }

    .table1 td, th {
        border: 1px solid black;
        text-align: center;
        padding: 8px 0;
    }
</style>
<template>
    <div style=" width:100%;background-color: white;display: flex;flex-direction: column;align-items: center">
        <div style="padding: 50px 0;font-size: 16px;width: 980px;">
            <div style="font-size: 26px;font-weight: bold;text-align: center;margin-top: 50px">重庆市江北区铁山坪社区卫生服务中心</div>
            <div style="font-size: 22px;text-align: center;margin-top: 20px">24小时动态血压监测报告</div>
            <div style="width: 100%;">
                <table style="width: 100%;margin-top: 20px;">
                    <tr>
                        <td colspan="5" align="right">编号：1352747 版本：2.0</td>
                    </tr>
                    <tr style="border: 1px solid #ccc;border-top: 1px solid black;">
                        <td align="left">受检者：{{info.name}}</td>
                        <td align="left">性别：{{info.sex}}</td>
                        <td align="left">年龄：{{info.age}}</td>
                        <td align="left">身高（cm）：{{info.height}}</td>
                        <td align="left">体重（kg）：{{info.weight}}</td>
                    </tr>
                    <tr style="border: 1px solid #cccccc;">
                        <td align="left">检查时间：{{info.date}}</td>
                        <td align="left">联系电话：{{info.mobile}}</td>
                        <td align="left">设备：{{info.type}}</td>
                        <td align="left"></td>
                        <td align="left"></td>
                    </tr>
                    <tr style="border: 1px solid #cccccc;">
                        <td align="left">科室：{{info.department}}</td>
                        <td align="left">住院号：{{info.admission}}</td>
                        <td align="left">床号：{{info.number}}</td>
                        <td align="left">门诊号：{{info.outpatient}}</td>
                        <td align="left"></td>
                    </tr>
                    <tr style="border: 1px solid #cccccc;">
                        <td align="left">测量部位：上臂</td>
                        <td align="left">袖带规格：</td>
                        <td align="left">白天活动水平：</td>
                        <td align="left">就寝时间：</td>
                        <td align="left">起床时间：</td>
                    </tr>
                    <tr style="border: 1px solid #cccccc;">
                        <td align="left">标准有无午睡：有/无</td>
                        <td align="left">午睡开始时间：</td>
                        <td align="left">午睡结束时间：</td>
                        <td align="left"></td>
                        <td align="left"></td>
                    </tr>
                    <tr style="border: 1px solid #cccccc;">
                        <td align="left">备注：{{info.icase}}</td>
                        <td align="left"></td>
                        <td align="left"></td>
                        <td align="left"></td>
                        <td align="left"></td>
                    </tr>

                    <tr style="border: 1px solid #cccccc;">
                        <td align="left">服用药物：</td>
                        <td align="left"></td>
                        <td align="left"></td>
                        <td align="left"></td>
                        <td align="left"></td>
                    </tr>
                    <tr style="border: 1px solid #cccccc;border-bottom: 1px solid black;">
                        <td align="left">说明：{{info.report_info}}</td>
                        <td align="left"></td>
                        <td align="left"></td>
                        <td align="left"></td>
                        <td align="left"></td>
                    </tr>
                </table>

                <div style="width: 100%;margin-top: 40px">ABPM统计表：</div>
                <table class="table1" style="width: 100%;border:1px solid black;">
                    <tr style="">
                        <td align="left" rowspan="2"></td>
                        <td align="center" colspan="3">白大衣窗口</td>
                        <td align="center" colspan="3">白天清醒时段({{info.night_end}}:00~({{info.night_start}}:00)</td>
                        <td align="center" colspan="3">夜间睡眠时段(({{info.night_start}}:00~{{info.night_end}}:00)</td>
                        <td align="center" colspan="3">起床后清醒时段({{info.night_end}}:00~{{info.night_end_two_hour}}:00)
                        </td>
                        <td align="center" colspan="3">24小时</td>
                    </tr>
                    <tr style="">

                        <td align="left">收缩压
                            mmHg
                        </td>
                        <td align="left">舒张压
                            mmHg
                        </td>
                        <td align="left">脉搏
                            bpm
                        </td>
                        <td align="left">收缩压
                            mmHg
                        </td>
                        <td align="left">舒张压
                            mmHg
                        </td>
                        <td align="left">脉搏
                            bpm
                        </td>
                        <td align="left">收缩压
                            mmHg
                        </td>
                        <td align="left">舒张压
                            mmHg
                        </td>
                        <td align="left">脉搏
                            bpm
                        </td>
                        <td align="left">收缩压
                            mmHg
                        </td>
                        <td align="left">舒张压
                            mmHg
                        </td>
                        <td align="left">脉搏
                            bpm
                        </td>
                        <td align="left">收缩压
                            mmHg
                        </td>
                        <td align="left">舒张压
                            mmHg
                        </td>
                        <td align="left">脉搏
                            bpm
                        </td>
                    </tr>
                    <tr style="">
                        <td align="left" style="width: 110px">有效数据个数 （百分比）</td>
                        <td align="left" colspan="3"></td>
                        <td align="left" colspan="3"> {{info.p00}}({{info.p01}}%)</td>
                        <td align="left" colspan="3"> {{info.p03}}({{info.p04}}%)</td>
                        <td align="left" colspan="3"> {{info.p06}}({{info.p07}}%)</td>
                        <td align="left" colspan="3"> {{info.p09}}({{info.p0a}}%)</td>

                    </tr>
                    <tr style="">
                        <td align="left">均值</td>
                        <td align="left"></td>
                        <td align="left"></td>
                        <td align="left"></td>
                        <td align="left">{{info.p10}}</td>
                        <td align="left">{{info.p11}}</td>
                        <td align="left">{{info.p12}}</td>
                        <td align="left">{{info.p13}}</td>
                        <td align="left">{{info.p14}}</td>
                        <td align="left">{{info.p15}}</td>
                        <td align="left">{{info.p16}}</td>
                        <td align="left">{{info.p17}}</td>
                        <td align="left">{{info.p18}}</td>
                        <td align="left">{{info.p19}}</td>
                        <td align="left">{{info.p1a}}</td>
                        <td align="left">{{info.p1b}}</td>
                    </tr>
                    <tr style="">
                        <td align="left">标准差</td>
                        <td align="left"></td>
                        <td align="left"></td>
                        <td align="left"></td>
                        <td align="left">{{info.p20}}</td>
                        <td align="left">{{info.p21}}</td>
                        <td align="left">{{info.p22}}</td>
                        <td align="left">{{info.p23}}</td>
                        <td align="left">{{info.p24}}</td>
                        <td align="left">{{info.p25}}</td>
                        <td align="left">{{info.p26}}</td>
                        <td align="left">{{info.p27}}</td>
                        <td align="left">{{info.p28}}</td>
                        <td align="left">{{info.p29}}</td>
                        <td align="left">{{info.p2a}}</td>
                        <td align="left">{{info.p2b}}</td>
                    </tr>
                    <tr style="">
                        <td align="left">最大值</td>
                        <td align="left"></td>
                        <td align="left"></td>
                        <td align="left"></td>
                        <td align="left">{{info.p30}}</td>
                        <td align="left">{{info.p31}}</td>
                        <td align="left">{{info.p32}}</td>
                        <td align="left">{{info.p33}}</td>
                        <td align="left">{{info.p34}}</td>
                        <td align="left">{{info.p35}}</td>
                        <td align="left">{{info.p36}}</td>
                        <td align="left">{{info.p37}}</td>
                        <td align="left">{{info.p38}}</td>
                        <td align="left">{{info.p39}}</td>
                        <td align="left">{{info.p3a}}</td>
                        <td align="left">{{info.p3b}}</td>
                    </tr>
                    <tr style="">
                        <td align="left">中位数</td>
                        <td align="left"></td>
                        <td align="left"></td>
                        <td align="left"></td>
                        <td align="left">{{info.p40}}</td>
                        <td align="left">{{info.p41}}</td>
                        <td align="left">{{info.p42}}</td>
                        <td align="left">{{info.p43}}</td>
                        <td align="left">{{info.p44}}</td>
                        <td align="left">{{info.p45}}</td>
                        <td align="left">{{info.p46}}</td>
                        <td align="left">{{info.p47}}</td>
                        <td align="left">{{info.p48}}</td>
                        <td align="left">{{info.p49}}</td>
                        <td align="left">{{info.p4a}}</td>
                        <td align="left">{{info.p4b}}</td>
                    </tr>
                    <tr style="">
                        <td align="left">最小值</td>
                        <td align="left"></td>
                        <td align="left"></td>
                        <td align="left"></td>
                        <td align="left">{{info.p50}}</td>
                        <td align="left">{{info.p51}}</td>
                        <td align="left">{{info.p52}}</td>
                        <td align="left">{{info.p53}}</td>
                        <td align="left">{{info.p54}}</td>
                        <td align="left">{{info.p55}}</td>
                        <td align="left">{{info.p56}}</td>
                        <td align="left">{{info.p57}}</td>
                        <td align="left">{{info.p58}}</td>
                        <td align="left">{{info.p59}}</td>
                        <td align="left">{{info.p5a}}</td>
                        <td align="left">{{info.p5b}}</td>
                    </tr>
                    <tr style="">
                        <td align="left">血压负荷</td>
                        <td align="left"></td>
                        <td align="left"></td>
                        <td align="left"></td>
                        <td align="left">{{info.p60}}</td>
                        <td align="left">{{info.p61}}</td>
                        <td align="left"></td>
                        <td align="left">{{info.p63}}</td>
                        <td align="left">{{info.p64}}</td>
                        <td align="left"></td>
                        <td align="left">{{info.p66}}</td>
                        <td align="left">{{info.p67}}</td>
                        <td align="left"></td>
                        <td align="left">{{info.p69}}</td>
                        <td align="left">{{info.p6a}}</td>
                        <td align="left"></td>
                    </tr>
                    <tr style="">
                        <td align="left">夜间血压下降</td>
                        <td align="left"></td>
                        <td align="left"></td>
                        <td align="left"></td>
                        <td align="left"></td>
                        <td align="left"></td>
                        <td align="left"></td>
                        <td align="left"></td>
                        <td align="left"></td>
                        <td align="left"></td>
                        <td align="left"></td>
                        <td align="left"></td>
                        <td align="left"></td>
                        <td align="left">{{info.p79 }}% {{info.c79}}</td>
                        <td align="left">{{info.p7a }}% {{info.c7a}}</td>
                        <td align="left"></td>
                    </tr>
                    <tr style="">
                        <td align="left">血压晨峰</td>
                        <td align="left"></td>
                        <td align="left"></td>
                        <td align="left"></td>
                        <td align="left"></td>
                        <td align="left"></td>
                        <td align="left"></td>
                        <td align="left"></td>
                        <td align="left"></td>
                        <td align="left"></td>
                        <td align="left"></td>
                        <td align="left"></td>
                        <td align="left"></td>

                        <td align="left">{{info.p89}}</td>
                        <td align="left">{{info.p8a}}</td>
                        <td align="left"></td>
                    </tr>
                    <tr style="">
                        <td align="left">变异系数</td>
                        <td align="left"></td>
                        <td align="left"></td>
                        <td align="left"></td>
                        <td align="left">{{info.p90}}</td>
                        <td align="left">{{info.p91}}</td>
                        <td align="left">{{info.p92}}</td>
                        <td align="left">{{info.p93}}</td>
                        <td align="left">{{info.p94}}</td>
                        <td align="left">{{info.p95}}</td>
                        <td align="left"></td>
                        <td align="left"></td>
                        <td align="left"></td>
                        <td align="left">{{info.p99}}</td>
                        <td align="left">{{info.p9a}}</td>
                        <td align="left">{{info.p9b}}</td>
                    </tr>
                    <tr style="">
                        <td align="left">脉压差均值</td>
                        <td align="left"></td>
                        <td align="left"></td>
                        <td align="left"></td>
                        <td align="left" colspan="3">{{info.pa0}}</td>
                        <td align="left" colspan="3">{{info.pa3}}</td>
                        <td align="left" colspan="3">{{info.pa6}}</td>
                        <td align="left" colspan="3">{{info.pa9}}</td>
                    </tr>
                    <tr style="">
                        <td align="left">动脉硬化指数</td>
                        <td align="left" colspan="3"></td>
                        <td align="left" colspan="3"></td>
                        <td align="left" colspan="3"></td>
                        <td align="left" colspan="3"></td>
                        <td align="left" colspan="3"></td>
                    </tr>
                    <tr style="">
                        <td align="left">盐敏感可能性</td>
                        <td align="left" colspan="15"></td>

                    </tr>
                    <tr style="">
                        <td align="left">小结</td>
                        <td align="left" colspan="15" style="text-align: left;line-height: 32px;padding-left: 10px">
                            24小时：收缩压{{info.c19}}、舒张压{{info.c1a}}（{{info.p19}}/{{info.p1a}}mmHg ，正常参考值 < 130/80 mmHg
                            ）；<br/>
                            白天清醒时段：收缩压{{info.c10}}、舒张压{{info.c11}}（{{info.p10}}/{{info.p11}}mmHg ，正常参考值 < 135/85 mmHg ）；<br/>
                            夜间睡眠时段：收缩压{{info.c13}}、舒张压{{info.c14}}（{{info.p13}}/{{info.p14}}mmHg ，正常参考值 < 120/70 mmHg ）；<br/>
                            起床后清晨时段：收缩压{{info.c16}}、舒张压{{info.c17}}（{{info.p16}}/{{info.p17}}mmHg ，正常参考值 < 135/85 mmHg
                            ）；<br/>
                            昼夜节律：收缩压昼夜节律为{{info.c79}}、舒张压昼夜节律{{info.c7a}}。
                        </td>
                    </tr>
                    <tr style="">
                        <td align="left" style="height: 160px">报告医生评估</td>
                        <td align="left" colspan="15">{{info.note}}</td>

                    </tr>
                    <tr style="">
                    <tr style="">
                        <td align="left">报告医生</td>
                        <td align="left" colspan="7"></td>
                        <td align="left" colspan="2">签名日期</td>
                        <td align="left" colspan="6">{{info.reportTime}}</td>
                    </tr>
                </table>


                <div style="font-size: 22px;text-align: center;margin-top: 150px">24小时动态血压监测报告</div>
                <table style="width: 100%;">
                    <tr style="border: 1px solid #ccc;border-top: 1px solid black;">
                        <td align="left">受检者：{{info.name}}</td>
                        <td align="left">性别：{{info.sex}}</td>
                        <td align="left">年龄：{{info.age}}</td>
                        <td align="left">身高（cm）：{{info.height}}</td>
                        <td align="left">体重（kg）：{{info.weight}}</td>
                    </tr>
                    <tr style="border: 1px solid #cccccc;">
                        <td align="left">检查时间：{{info.date}}</td>
                        <td align="left">联系电话：{{info.mobile}}</td>
                        <td align="left">设备：{{info.type}}</td>
                        <td align="left"></td>
                        <td align="left"></td>
                    </tr>
                </table>

                <!--折线图--->
                <div id="line_Systolic" ref="scatterChart" style="width: 100%; height: 500px;margin-top: 50px"></div>
                <div id="line_Diastolic" ref="scatterChart" style="width: 100%; height: 500px;margin-top: 50px"></div>
                <div id="line_hr" ref="scatterChart" style="width: 100%; height: 500px;margin-top: 50px"></div>
                <!----柱状图--->
                <div id="bar_Systolic" ref="scatterChart" style="width: 100%; height: 500px;margin-top: 250px"></div>
                <div id="bar_Diastolic" ref="scatterChart" style="width: 100%; height: 500px;margin-top: 150px"></div>
                <div id="bar_hr" ref="scatterChart" style="width: 100%; height: 500px;margin-top: 150px"></div>
                <!----饼图--->
                <div id="pie_Systolic" ref="scatterChart" style="width: 100%; height: 500px;margin-top: 350px"></div>
                <div id="pie_Diastolic" ref="scatterChart" style="width: 100%; height: 500px;margin-top: 150px"></div>
                <div id="pie_hr" ref="scatterChart" style="width: 100%; height: 500px;margin-top: 150px"></div>

                <div style="margin-top: 80px;font-size: 22px;text-align: center">24小时动态血压监测报告</div>
                <table style="width: 100%;">
                    <tr style="border: 1px solid #ccc;border-top: 1px solid black;">
                        <td align="left">受检者：{{info.name}}</td>
                        <td align="left">性别：{{info.sex}}</td>
                        <td align="left">年龄：{{info.age}}</td>
                        <td align="left">身高（cm）：{{info.height}}</td>
                        <td align="left">体重（kg）：{{info.weight}}</td>
                    </tr>
                    <tr style="border: 1px solid #cccccc;">
                        <td align="left">检查时间：{{info.date}}</td>
                        <td align="left">联系电话：{{info.mobile}}</td>
                        <td align="left">设备：{{info.type}}</td>
                        <td align="left"></td>
                        <td align="left"></td>
                    </tr>
                </table>
                <!----散点图--->
                <div style="display: flex;justify-content: space-between;margin-top:150px">
                    <div id="myChartNumber1" ref="scatterChart" style="width: 500px; height: 500px;"></div>
                    <div id="myChartNumber2" ref="scatterChart" style="width: 500px; height: 500px;"></div>
                </div>
                <div style="display: flex;justify-content: space-between">
                    <div id="myChartNumber3" ref="scatterChart" style="width: 500px; height: 500px;"></div>
                    <div id="myChartNumber4" ref="scatterChart" style="width: 500px; height: 500px;"></div>
                </div>
                <div style="display: flex;justify-content: space-between;margin-top: 100px">
                    <div id="myChartNumber5" ref="scatterChart" style="width: 500px; height: 500px;"></div>
                    <div id="myChartNumber6" ref="scatterChart" style="width: 500px; height: 500px;"></div>
                </div>
                <div style="margin-top: 50px;font-size: 22px;text-align: center">24小时动态血压监测报告</div>
                <table style="width: 100%;">
                    <tr style="border: 1px solid #ccc;border-top: 1px solid black;">
                        <td align="left">受检者：{{info.name}}</td>
                        <td align="left">性别：{{info.sex}}</td>
                        <td align="left">年龄：{{info.age}}</td>
                        <td align="left">身高（cm）：{{info.height}}</td>
                        <td align="left">体重（kg）：{{info.weight}}</td>
                    </tr>
                    <tr style="border: 1px solid #cccccc;">
                        <td align="left">检查时间：{{info.date}}</td>
                        <td align="left">联系电话：{{info.mobile}}</td>
                        <td align="left">设备：{{info.type}}</td>
                        <td align="left"></td>
                        <td align="left"></td>
                    </tr>
                </table>
                <table class="table1" style="width: 100%;margin-top: 10px">
                    <tr v-for="item in tablec">

                        <td v-for="item1 in item" v-if="table_b.includes(item[0])"
                            style="background-color: #cccccc;color: black">{{item1}}
                        </td>
                        <td v-for="item1 in item" v-if="!table_b.includes(item[0])">{{item1}}</td>
                    </tr>
                </table>
            </div>

        </div>
    </div>
</template>
<script>
    import * as echarts from 'echarts';
    import request from "../../plugins/axios";

    export default {
        components: {},
        data() {
            return {
                info: "",
                tablec: [],
                table_b: []
            };
        },
        created() {

            this.getData()
        },
        mounted() {


        },
        methods: {
            getData() {
                let that = this
                let id = localStorage.getItem('doc_id');
                let type = 'web'
                request({
                    url: "/hospital/Read/make_web",
                    data: {
                        id
                    },
                }).then((ret) => {
                    if (ret.code == 1) {
                        that.info = ret.data.info
                        that.table_b = ret.data.table_b
                        that.tablec = ret.data.tablec
                        this.charts_line("line_Systolic", '24小时收缩压趋势图', '', '', ret.data.line_kkbp[0], ret.data.line_kkbp[3]);
                        this.charts_line("line_Diastolic", '24小时舒张压趋势图', '', '', ret.data.line_kkbp[1], ret.data.line_kkbp[3]);
                        this.charts_line("line_hr", '24小时心率趋势图', '', '', ret.data.line_kkbp[2], ret.data.line_kkbp[3]);
                        this.charts_bar("bar_Systolic", '24小时收缩压百分比', '', '', ret.data.bar_kkbp[0], ret.data.bar_kkbp[1]);
                        this.charts_bar("bar_Diastolic", '24小时舒张压百分比', '', '', ret.data.bar_kkbp[2], ret.data.bar_kkbp[3]);
                        this.charts_bar("bar_hr", '24小时心率百分比', '', '', ret.data.bar_kkbp[4], ret.data.bar_kkbp[5]);
                        this.charts_pie("pie_Systolic", '舒张压占比', '', '', ret.data.pie.chart_s_bing);
                        this.charts_pie("pie_Diastolic", '收缩压占比', '', '', ret.data.pie.chart_d_bing);
                        this.charts_pie("pie_hr", '心率占比', '', '', ret.data.pie.chart_hr_bing);
                        this.charts_scatter("myChartNumber1", '收缩压/舒张压-全程', ret.data.scatter.all_sc);
                        this.charts_scatter("myChartNumber2", '收缩压/心率-全程', ret.data.scatter.all_sh);
                        this.charts_scatter("myChartNumber3", '收缩压/舒张压-白天', ret.data.scatter.day_sc);
                        this.charts_scatter("myChartNumber4", '收缩压/心率-白天', ret.data.scatter.day_sh);
                        this.charts_scatter("myChartNumber5", '收缩压/舒张压-黑夜', ret.data.scatter.night_sc);
                        this.charts_scatter("myChartNumber6", '收缩压/心率-黑夜', ret.data.scatter.night_sh);
                    }
                });
            },
            charts_line(id, title, max_x, max_y, data_x, data_y) {
                let chartDom = document.getElementById(id);
                let myChart = echarts.init(chartDom);
                let option = {
                    title: {
                        text: title,
                        left: 'center'
                    },
                    xAxis: {
                        name: '时间',
                        type: 'category',
                        boundaryGap: false,
                        data: data_y,
                        axisLabel: {
                            rotate: 90 // 设置文字倾斜角度，这里以45度为例
                        },
                        splitLine: {
                            show: true // 显示 X 轴的分割线
                        }
                    },
                    tooltip: {
                        trigger: 'axis'
                    },
                    yAxis: {
                        name: '收缩压值',
                        type: 'value',
                        splitLine: {
                            show: true // 显示 X 轴的分割线
                        }
                    },
                    grid: {
                        show: true
                    },
                    series: [
                        {
                            data: data_x,
                            type: 'line',
                            smooth: true,
                            itemStyle: {
                                color: '#749ce2'
                            },
                        }
                    ]
                };
                myChart.setOption(option);
            },
            charts_bar(id, title, max_x, max_y, data_x, data_y) {
                let chartDom = document.getElementById(id);
                let myChart = echarts.init(chartDom);
                let option = {
                    title: {
                        text: title,
                        left: 'center'
                    },
                    tooltip: {
                        axisPointer: {
                            type: 'shadow'
                        }
                    },
                    legend: {},
                    grid: {
                        left: '3%',
                        right: '4%',
                        bottom: '3%',
                        containLabel: true
                    },
                    xAxis: {
                        type: 'value',
                        boundaryGap: [0, 0.01]
                    },
                    yAxis: {
                        type: 'category',
                        data: data_x
                    },
                    series: [
                        {
                            type: 'bar',
                            data: data_y,
                            itemStyle: {
                                color: '#749ce2'
                            },
                            label: {
                                show: true, // 开启显示
                                position: 'right', // 标签的位置，可以是 'top', 'bottom', 'left', 'right' 或者使用绝对位置，如 ['x%', 'y%']

                            }
                        },
                    ]
                };
                myChart.setOption(option);
            },
            charts_pie(id, title, max_x, max_y, data_x) {
                let chartDom = document.getElementById(id);
                let myChart = echarts.init(chartDom);
                let option = {
                    color: ['#DE4949', '#AEE5AE', '#FADF88'],
                    title: {
                        text: title,
                        left: 'center'
                    },
                    tooltip: {
                        trigger: 'item'
                    },
                    legend: {
                        orient: 'vertical',
                        left: 'left'
                    },
                    series: [
                        {
                            label: {
                                show: true, // 开启显示
                                formatter: '{b}:  ({d}%)',
                                fontSize: 18,
                                color: "#000"
                            },
                            name: 'Access From',
                            type: 'pie',
                            radius: '50%',
                            data: data_x,
                            emphasis: {
                                itemStyle: {
                                    shadowBlur: 10,
                                    shadowOffsetX: 0,
                                    shadowColor: 'rgba(0, 0, 0, 0.5)'
                                }
                            }
                        }
                    ]
                };
                myChart.setOption(option);
            },
            charts_scatter(id, title, data_o) {
                let chartDom = document.getElementById(id);
                let myChart = echarts.init(chartDom);
                let option = {
                    title: {
                        text: title,
                        left: 'center'
                    },
                    tooltip: {
                        formatter: function (params) {
                            // params.data 是当前点的数据值，params.seriesName 是系列名称，params.name 是数据项名称（如果有的话）
                            // 这里直接返回坐标值和数据值，你也可以根据需要自定义格式
                            return `坐标: (${params.data[0]}, ${params.data[1]})<br/>`;
                        }
                    },
                    xAxis: {
                        min: 0,
                        max: 200
                    },
                    yAxis: {
                        min: 0,
                        max: 200
                    },
                    series: [
                        {
                            label: {},
                            symbolSize: 10,
                            data: data_o,
                            type: 'scatter',
                        }
                    ]
                };
                myChart.setOption(option);
            },

        }
    };
</script>
